import { Twitter } from '@/components/Twitter';
import { LabradorComponent } from '@/types/component';

export const LabradorTwitter: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <Twitter markup={data.oembed.html} data-content-index={meta.contentIndex} {...props} />;
};
